<template>
  <div class="container py-5">
    <JobDescriptionHeader
        title="دوره‌های آموزشی، میزان آگاهی، اختیارات و سلسه مراتب"
        description="در این بخش می‌توانید دوره‌های آموزشی مرتبط با شایستگی‌، میزان آگاهی از مقررات، اختیارات و سلسله مراتب مسئولیت را ایجاد و به‌روزرسانی کنید"
    />

    <div class="row mt-4">
      <div class="col-md-6">
        <CompetencyCoursesSection/>
      </div>
      <div class="col-md-6">
        <RulesSection/>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-6">
        <PowersSection/>
      </div>
      <div class="col-md-6">
        <ResponsibilitiesHierarchySection/>
      </div>
    </div>

    <NavigationButtons @next="$emit('next')" @prev="$emit('prev')" />
  </div>
</template>

<script>
import NavigationButtons from "@/components/JobDescription/GeneralComponents/NavigationButtons.vue";
import JobDescriptionHeader from "@/components/JobDescription/GeneralComponents/JobDescriptionHeader.vue";
import CompetencyCoursesSection from "@/components/JobDescription/StepSix/CompetencyCoursesSection.vue";
import RulesSection from "@/components/JobDescription/StepSix/RulesSection.vue";
import PowersSection from "@/components/JobDescription/StepSix/PowersSection.vue";
import ResponsibilitiesHierarchySection from "@/components/JobDescription/StepSix/ResponsibilitiesHierarchySection.vue";

export default {
  components: {ResponsibilitiesHierarchySection, PowersSection, RulesSection, CompetencyCoursesSection, JobDescriptionHeader, NavigationButtons}
};
</script>
